import { resolveEnvironmentVariables } from '../utils/_env';

const {
  ENV_NAME,
  IS_DEV,
  IS_TEST,
  IS_PROD,
  IS_PRERELEASE,
  IS_RESERVE,
  IS_ZJ_PROD,
  IS_JYH_PROD,
  IS_JYH_RESERVE,
  IS_JYH_PROD_DOMAIN,
  IS_CAPTCHA_SKIPPED,
  IS_LIAR_HOME_VISIBLE,
} = resolveEnvironmentVariables();

export {
  ENV_NAME,
  IS_DEV,
  IS_TEST,
  IS_PROD,
  IS_PRERELEASE,
  IS_RESERVE,
  IS_ZJ_PROD,
  IS_JYH_PROD,
  IS_JYH_RESERVE,
  IS_JYH_PROD_DOMAIN,
  IS_CAPTCHA_SKIPPED,
  IS_LIAR_HOME_VISIBLE,
};
